import { render, staticRenderFns } from "./BeFormGroup.vue?vue&type=template&id=630cd38c&"
import script from "./BeFormGroup.vue?vue&type=script&lang=js&"
export * from "./BeFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports